// extracted by mini-css-extract-plugin
export default {"theme__light":"RichText-module--theme__light--boNbC","theme__dark":"RichText-module--theme__dark--ssAEe"};